var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{staticClass:"mr-2",attrs:{"append-icon":"mdi-magnify","clearable":"","dense":"","hide-details":"","hint":_vm.hint,"label":"Suche","outlined":"","persistent-hint":"","single-line":""},model:{value:(_vm.modelValue),callback:function ($$v) {_vm.modelValue=$$v},expression:"modelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }